// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.email-tooltip[data-v-72f61998] {\n\tdisplay: inline;\n\tfont-weight: 500 !important;\n\tfont-size: 13px !important;\n}\n.multiview-wrapper[data-v-72f61998] {\n\tmin-height: 300px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
